import { textAreaStyles as a } from "./text-area.styles.js";
import { textAreaTemplate as i } from "./text-area.template.js";
import { FASTTextArea as o } from "@matrix42/fast-foundation";
import { applyMixins as s } from "../common/apply-mixins.js";
import { InputMixin as l } from "../common/mixins/input-mixin.js";
const e = class e extends o {
  connectedCallback() {
    super.connectedCallback(), this.postConnectedCallback();
  }
  validate() {
    super.validate(), this.postValidate();
  }
};
e.definition = {
  name: "text-area",
  template: () => i,
  styles: a,
  shadowOptions: {
    delegatesFocus: !0
  }
};
let t = e;
s(t, l);
export {
  t as TextArea
};
